import { lazy } from "react";
import ReactDOM from "react-dom/client";

// Import order of css is important
import "./index.css";

import { setupSentry } from "#/services/sentry";

setupSentry();

export const AppWrapper = lazy(() => import("#/components/app/AppWrapper.tsx"));

ReactDOM.createRoot(document.getElementById("root")!).render(<AppWrapper />);
